import React from 'react'
import TransferenciaEntreContasFormPageContainer from './TransferenciaEntreContasFormPageContainer'

export class TransferenciaEntreContasFormPage extends React.Component {
  render() {
    return <TransferenciaEntreContasFormPageContainer {...this.props} />
  }
}
